import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class coinjar extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'Coinjar')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
			<section className="case-study"> 

			    <div className="container">

			        <div className="title">

			            <a href="https://coinjar.com.au" target="_blank"><img src="/images/new/logos/coinjar.svg"/></a>
			            <h3>Making digital currency accessible</h3>
			            <p>A Melbourne-based start up, CoinJar was built for the everyday bitcoin buyer. The platform works to make online finance easy, offering digital wallet and exchange services, along with Australia's first digital currency EFTPOS card. Since their 2013 launch, CoinJar has processed over $1 billion in exchange transactions for over 350,000 users.</p>

			        </div>

			        <div className="block">

			                <h4>Joining the dots</h4>
			                <p>A world leader online, CoinJar sought out ways to extend their products and services to physical storefronts. blueshyft stepped up to the plate, connecting the CoinJar platform to the nation-wide blueshyft network to provide customers with the ability to make instant payments in store. The benefits included:</p>

			            <div className="features">

			                <div className="feature">
			                    <img src="/images/new/icons/cash-blue.svg"/>
			                    <p>Instant in-store payments</p>
			                </div>
			                <div className="feature">
			                    <img src="/images/new/icons/cross-blue.svg"/>
			                    <p>Irreversible, fraud-proof purchases</p>
			                </div>
			                <div className="feature">
			                    <img src="/images/new/icons/map-blue.svg"/>
			                    <p>1,500+ convenient locations</p>
			                </div>

			            </div>
			    
			        </div>

			        <div className="block">

			            <h4>A streamlined solution</h4>
			            <p>blueshyft combined forces with CoinJar to roll out a large-scale service and logistics upgrade, including:</p>
			            <p>•  Instant payments - any customer with a CoinJar account can make a payment in store and have their account credited instantly</p>
			            <p>•  Irreversible, fraud-proof purchases - secure face-to-face transactions with no charge backs</p>
			            <p>•  A nation-wide network - with over 1,500+ locations across Australia, CoinJar's customers now have bitcoin, ethereum, litecoin and more at their fingertips via a simple, user-friendly service</p>

			        </div>

			        <div className="highlight">

			            <p>blueshyft's partnership with CoinJar means customers can make payments directly into their CoinJar accounts at one of 1400+ retail locations across the country. Since launch, CoinJar have boosted the number of transactions processed spectacularly.. Committed to building simple, smart digital financing tools, the partnership promises a huge step up in customer convenience and transaction speed.</p>
			    
			        </div>

			    </div>


			</section>

			<MoreCaseStudies cases={['lb', 'goget', 'news']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/coinjar/index.js